import { ModuleBase } from "../base";
import { ICoordPair } from "./TwoPointsPicker";
import { Component, Mixins } from 'vue-property-decorator';
import ToolMenu from './Menu.vue';
import SurfaceLayer from './SurfaceLayer.vue';
import ContextMenu from "./ContextMenu.vue";
import { KeyPress } from '@/utils/keypress';

export enum ToolType {
  PAN = 'PAN',
  RECT_SELECT = 'RECT_SELECT',
  LINE_SELECT = 'LINE_SELECT',
  TAN_RECT_SELECT = 'TAN_RECT_SELECT',
}

@Component
export class ToolModule extends Mixins(ModuleBase) {
  type = ToolType.PAN
  rect: ICoordPair | null = null
  line: ICoordPair | null = null

  get outlet() {
    return {
      toolMenu: ToolMenu,
      surfaceLayer: SurfaceLayer,
      contextMenu: ContextMenu,
    } as any
  }

  get keypress() {
    return [new RectSelectKeyPress(this), new LineSelectKeyPress(this)]
  }
}

class RectSelectKeyPress extends KeyPress {
  key = 'Shift'
  shift = true
  constructor(readonly module: ToolModule) { super() }

  down() {
    this.module.type = ToolType.RECT_SELECT
  }

  up() {
    this.module.type = ToolType.PAN
  }
}

class LineSelectKeyPress extends KeyPress {
  key = 'Meta'
  meta = true
  constructor(readonly module: ToolModule) { super() }

  down() {
    this.module.type = ToolType.LINE_SELECT
  }

  up() {
    this.module.type = ToolType.PAN
  }
}
